import { render, staticRenderFns } from "./BenefitsView.vue?vue&type=template&id=392b0f58&"
import script from "./BenefitsView.vue?vue&type=script&lang=js&"
export * from "./BenefitsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports